<head>
  <link rel="stylesheet" type="text/css" href="http://jsxgraph.uni-bayreuth.de/distrib/jsxgraph.css" />
</head>
<script lang="ts">
  import JXG from 'jsxgraph/distrib/jsxgraphcore.js';
  import { onMount } from 'svelte';
  import uqnSplit from './functions/uqnSplit';
  import Complex from './functions/complexClass';
  export let uqn:number;
  var brd;
  let initialized = false, brdDummy = "";
  $: brdDummy = updateBoard(uqn);

	onMount(() => {
    initialized = true;
    updateBoard(uqn);
  });

  function updateBoard(u:number):string{
    let [t,a,s] = uqnSplit(u);
    if (initialized){
      const max = Math.ceil(1.1*2*a);
      brd = JXG.JSXGraph.initBoard('jxgbox',{axis:true,boundingbox: [-max, max, max, -max]});
      brd.suspendUpdate();
      if (s==1){
        a *= -1;
      }
      let x1: number, y1: number;
      let x2: number, y2: number;
      let x3: number, y3: number;
      let x4: number, y4: number;
      let x5: number, y5: number;
      if (t==1 || t==2){ // \pm sqrt{3} + i
        x1 = Math.abs(a)*Math.sqrt(3); y1 = a;
        x2 = 0; y2 = 2*Math.abs(a);
        if (s==1){
          y2 *= -1;
        }
      } else{
        x1 = a; y1 = Math.abs(a)*Math.sqrt(3)
        y2 = 0; x2 = 2*Math.abs(a);
        if (s==0){
          x2 *= -1;
        }
      }
      x3 = x1; y3 = -y1;
      x4 = x3/2; y4=y3/2;
      let complex5 = new Complex(x1,y1);
      complex5 = complex5.pow(2);
      x5 = complex5.a/2/Math.abs(a)/complex5.denom; y5 = complex5.b/2/Math.abs(a)/complex5.denom;
      brd.create('grid',[]);
      brd.create('point',[x1,y1], {name:"A"});
      brd.create('point',[x2,y2], {name:"B"});
      brd.create('point',[x3,y3], {name:"C"});
      brd.create('point',[x4,y4], {name:"D"});
      if ( !((t==3||t==4) && s==1) ){
        brd.create('point',[x5,y5], {name:"E"});
      };
      brd.unsuspendUpdate();
    }
    return "";
  }
</script>
<div id="jxgbox" style="width:350px; height:350px;">{brd}</div>